import "./ShippingWarrantyAndOrdering.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Freight from "./sections/Freight";
import Inclusions from "./sections/Inclusions";
import Delivery from "./sections/Delivery";
import ShippingFactors from "./sections/ShippingFactors";
import Checklist from "./sections/Checklist";
import Receiving from "./sections/Receiving";
import Guidance from "./sections/Guidance";
import Ordering from "./sections/Ordering";
import Advisory from "./sections/Advisory";
import WarrantySupport from "./sections/WarrantySupport";
import ProductSupport from "./sections/ProductSupport";
import Replacementpartsadvisory from "./sections/Replacementpartsadvisory";
import Comparison from "./sections/Comparison";
import ShippingFaq from "./sections/ShippingFaq";
import DeliveryPlate from "./sections/DeliveryPlate";
import Footer from "@/reusable_sections/Footer";
export default function ShippingWarrantyAndOrderingPage() {
  return <div>
      <Header />
      <Hero />
      <Freight />
      <Inclusions />
      <Delivery />
      <ShippingFactors />
      <Checklist />
      <Receiving />
      <Guidance />
      <Ordering />
      <Advisory />
      <WarrantySupport />
      <ProductSupport />
      <Replacementpartsadvisory />
      <Comparison />
      <ShippingFaq />
      <DeliveryPlate />
      <Footer />
    </div>;
}